<script>
export default
{
    name: 'layout-guest',

    data()
    {
        return {
            title: process.env.TITLE,
        }

    },
}
</script>

<template>

    <div class="vertical-center">

        <div class="container text-center">
            <h1 class="text-primary text-stilusos">{{ title }}</h1>
        </div>

        <p></p>

        <transition name="slide-vertical" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>

</template>


// WEBPACK FOOTER //
// src/layouts/Guest.vue